import React from "react";
import halfandhalf from "../images/halfandhalf.png";
const History = () => {
  return (
    <div className="history brush-top brush-bottom">
      <div className="container full-height">
        <div className="pre-text">what’s it really called?</div>
        <div className="header">
          <div className="red">zobo? roselle?</div>
          <div className="black">agua? bissap?</div>
        </div>

        <div className="desc">
          <div className="desc-1">
            Rooted in West African tradition, Zobo—made from dried hibiscus petals—has long been cherished for its vibrant flavor and healthy
            benefits...
          </div>
          <div className="image">
            <img src={halfandhalf} alt="bowl of fresh and dried hisbiscus tea leaves" />
          </div>
          <div className="desc-2">
            This iconic drink, a staple at celebrations and everyday gatherings, carries the rich heritage of Nigeria in every refreshing sip.
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;
